module.exports = __webpack_public_path__ + "71e664b46f705e3ac6f2a8e9923b5d64.png";